export var countries = []; // Array to store country data
export var paymentSystem = []; // Array to store payment system data
export var cashDesks = []; // Array to store cash desk information
export var agentList = []; // Array to store agent information
export var concepts = []; // Array to store various concepts
export var accountingAccounts = []; // Array to store accounting accounts
export var providersSMS = []; // Array to store SMS providers
export var providersEmail = []; // Array to store email providers
export var providerPaymentWithdrawal = []; // Array to store payment withdrawal providers
export var perm = []; // Array to store permissions
export var requestPerm = ''; // Variable to store permission requests
export var defaultDataFetch = 10; // Default number of data items to fetch
export var providersCasino = []; // Array to store casino providers
export var subprovidersCasino = []; // Array to store subproviders for casinos
export var gamesCasino = []; // Array to store casino games
export var walletsList = []; // Array to store wallet information
export var startDate = ''; // Variable to store the start date
export var endDate = ''; // Variable to store the end date
export let version = ''; // Variable to store the version
export let relationshipUserOnline = ''; // Variable to store online user relationship
export let onRelationshipUserOnline = false; // Flag for online user relationship status
export let onRelationshipUserOnlineVirtuals = false; // Flag for virtual online user relationship status
export var walletcode = '190582'; // Default wallet code
export var urlJs = ''; // Variable to store JavaScript URL
export var urlCasinoPlay = ''; // Variable to store casino play URL
export var src = ''; // Variable to store source information
export var urlJs2 = ''; // Variable to store a second JavaScript URL
export var skinid = 'doradobet'; // Variable to store skin ID
export var profile = []; // Array to store user profile information
export var machines = []; // Array to store machine information
export var banners = []; // Array to store banner information
export var awardsReferrals = []; // Array to store referral awards
export var conditionsReferrals = []; // Array to store referral conditions
export var ClouserId = ''; // Variable to store Clouser ID
export var KeySocket = ''; // Variable to store WebSocket key
export var UsuMandanteId = ''; // Variable to store user mandate ID
export var menus = []; // Array to store menu information
export var prm = ''; // Variable to store permissions
const currentDomain = window.location.href; // Get the current domain from the window location
export var recapchaLogin = currentDomain.includes('admsp-') ? false : process.env.RECAPTCHA_LOGIN || false; // Determine if reCAPTCHA login is enabled based on the current domain

export const devConfig = {
    /**
     * Retrieves the API URL based on the environment configuration.
     * @returns {string} The API URL.
     */
    geturlApi: () => {
               let urlApi = process.env.API_URL || 'https://backofficeapi.virtualsoft.tech/'; // Default API URL
        if (true) { // Placeholder for condition
            walletcode = '190582'; // Set wallet code
            urlJs = 'https://sb1client-altenar.biahosted.com/static/AltenarSportsbook.js'; // Set JavaScript URL
            urlCasinoPlay = process.env.API_URL_CASINO_PLAY || 'https://casino.virtualsoft.tech/game/play/?gameid=207629&mode=real&provider=XPRESS&balance=0'; // Set casino play URL
        } else {
            walletcode = '030817'; // Alternative wallet code
            urlJs = 'https://sb1client-altenar-stage.biahosted.com/static/AltenarSportsbook.js'; // Alternative JavaScript URL
            urlJs2 = ''; // Reset second JavaScript URL
            urlCasinoPlay = process.env.API_URL_CASINO_PLAY || 'https://apidevintegrations.virtualsoft.tech/casino/game/play/?gameid=2682&mode=real&provider=XPRESS&balance=0'; // Alternative casino play URL
        }
        urlCasinoPlay = 'https://casino.virtualsoft.tech/game/play/?gameid=207629&mode=real&provider=XPRESS&balance=0'; // Set casino play URL again
        const currentDomain = window.location.href; // Get the current domain
        if (currentDomain.includes('admsp-')) { // Check if the domain includes 'admsp-'
            const domainRegex = /(admsp-)(vsft-\d+)/; // Regex to match specific domain pattern
            const domainMatch = currentDomain.match(domainRegex); // Match the current domain against the regex
            const subdomain = domainMatch[2]; // Extract subdomain from match
            const apiUrlRegex = /^(https:\/\/)([^.]+)\.([^.]+)\.([^\/]+)(\/.*)$/; // Regex to match API URL structure
            const apiUrlMatch = urlApi.match(apiUrlRegex); // Match the API URL against the regex
            if (apiUrlMatch) {
                const apiProtocol = apiUrlMatch[1]; // Extract protocol from match
                const apiSubdomain = apiUrlMatch[2]; // Extract subdomain from match
                const apiDomain = apiUrlMatch[3]; // Extract domain from match
                const apiTld = apiUrlMatch[4]; // Extract top-level domain from match
                const apiPath = apiUrlMatch[5]; // Extract path from match
                urlApi = `${apiProtocol}${apiSubdomain}-${subdomain}.${apiDomain}.${apiTld}${apiPath}`; // Construct new API URL
            }
        }
        return urlApi; // Return the constructed API URL
    },
    /**
     * Retrieves the WebSocket URL based on the environment configuration.
     * @returns {string} The WebSocket URL.
     */
    getUrlWs: () => {
        let urlWs = process.env.WS_URL || 'wss://CLOUSERID.piesocket.com/v3/CHANNELID?api_key=APIKEY&notify_self'; // Default WebSocket URL
        return urlWs; // Return the WebSocket URL
    },
    /**
     * Retrieves the reCAPTCHA login status based on the current domain.
     * @returns {boolean} The reCAPTCHA login status.
     */
    getRecapchaLogin: () => {
        recapchaLogin = currentDomain.includes('admsp-') ? false : process.env.RECAPTCHA_LOGIN || false; // Determine reCAPTCHA login status
        return recapchaLogin; // Return the reCAPTCHA login status
    },
    /**
     * Retrieves the repository type.
     * @returns {number} The repository type.
     */
    getRepositoryType: () => {
        return 1; // Return the repository type
    },
    /**
     * Initializes permission handling for elements with 'prm-' class.
     */
    classprm: () => {
        $(document).on('click', 'div[class*="prm-"]', function({ currentTarget }) {
            const elementClass = Array.prototype.slice.call(currentTarget.classList); // Get the class list of the clicked element
            const permission = elementClass.find((item) => item.includes('prm')); // Find permission class
            if (permission != undefined) {
                const local = permission.split('-')[1]; // Extract local permission identifier
                if (local != undefined && local != '') {
                    devConfig.setPrm(local); // Set permission
                    console.log(devConfig.getPrm()); // Log the current permission
                }
            }
        });
        $(document).on('click', 'span[class*="prm-"]', function({ currentTarget }) {
            const elementClass = Array.prototype.slice.call(currentTarget.classList); // Get the class list of the clicked element
            const permission = elementClass.find((item) => item.includes('prm')); // Find permission class
            if (permission != undefined) {
                const local = permission.split('-')[1]; // Extract local permission identifier
                if (local != undefined && local != '') {
                    devConfig.setPrm(local); // Set permission
                    console.log(devConfig.getPrm()); // Log the current permission
                }
            }
        });
    },
    /**
     * Sets the WebSocket key.
     * @param {string} c - The WebSocket key to set.
     */
    setKeySocket: (c) => {
        KeySocket = c; // Set the WebSocket key
    },
    /**
     * Sets the Clouser ID.
     * @param {string} c - The Clouser ID to set.
     */
    setClouserId: (c) => {
        ClouserId = c; // Set the Clouser ID
    },
    /**
     * Retrieves the WebSocket key.
     * @returns {string} The WebSocket key.
     */
    getKeySocket: () => {
        return KeySocket; // Return the WebSocket key
    },
    /**
     * Retrieves the Clouser ID.
     * @returns {string} The Clouser ID.
     */
    getClouserId: () => {
        return ClouserId; // Return the Clouser ID
    },
    /**
     * Sets the user mandate ID.
     * @param {string} c - The user mandate ID to set.
     */
    setUsuMandanteId: (c) => {
        UsuMandanteId = c; // Set the user mandate ID
    },
    /**
     * Retrieves the user mandate ID.
     * @returns {string} The user mandate ID.
     */
    getUsuMandanteId: () => {
        return UsuMandanteId; // Return the user mandate ID
    },
    /**
     * Sets the payment system.
     * @param {Array} c - The payment system data to set.
     */
    setPaymentSystem: (c) => {
        paymentSystem = c; // Set the payment system data
    },
    /**
     * Sets the cash desks.
     * @param {Array} c - The cash desks data to set.
     */
    setCashDesks: (c) => {
        cashDesks = c; // Set the cash desks data
    },
    /**
     * Sets the agent list.
     * @param {Array} c - The agent list data to set.
     */
    setAgentList: (c) => {
        agentList = c; // Set the agent list data
    },
    /**
     * Sets the concepts.
     * @param {Array} c - The concepts data to set.
     */
    setConcepts: (c) => {
        console.log(c); // Log the concepts data
        concepts = c; // Set the concepts data
    },
    /**
     * Sets the accounting accounts.
     * @param {Array} c - The accounting accounts data to set.
     */
    setAccountingAccounts: (c) => {
        accountingAccounts = c; // Set the accounting accounts data
    },
    /**
     * Sets the SMS providers.
     * @param {Array} c - The SMS providers data to set.
     */
    setProvidersSMS: (c) => {
        providersSMS = c; // Set the SMS providers data
    },
    /**
     * Sets the email providers.
     * @param {Array} c - The email providers data to set.
     */
    setProvidersEmail: (c) => {
        providersEmail = c; // Set the email providers data
    },
    /**
     * Sets the payment withdrawal providers.
     * @param {Array} c - The payment withdrawal providers data to set.
     */
    setProviderPaymentWithdrawal: (c) => {
        providerPaymentWithdrawal = c; // Set the payment withdrawal providers data
    },
    /**
     * Sets the countries.
     * @param {Array} c - The countries data to set.
     */
    setCountries: (c) => {
        countries = c; // Set the countries data
    },
    /**
     * Retrieves the countries.
     * @returns {Array} The countries data.
     */
    getCountries: () => {
        return countries; // Return the countries data
    },
    /**
     * Sets the referral awards.
     * @param {Array} c - The referral awards data to set.
     */
    setAwardsReferrals: (c) => {
        awardsReferrals = c; // Set the referral awards data
    },
    /**
     * Retrieves the referral awards.
     * @returns {Array} The referral awards data.
     */
    getAwardsReferrals: () => {
        return awardsReferrals; // Return the referral awards data
    },
    /**
     * Sets the referral conditions.
     * @param {Array} c - The referral conditions data to set.
     */
    setConditionsReferrals: (c) => {
        conditionsReferrals = c; // Set the referral conditions data
    },
    /**
     * Retrieves the referral conditions.
     * @returns {Array} The referral conditions data.
     */
    getConditionsReferrals: () => {
        return conditionsReferrals; // Return the referral conditions data
    },
    /**
     * Sets the casino providers.
     * @param {Array} c - The casino providers data to set.
     */
    setProvidersCasino: (c) => {
        providersCasino = c; // Set the casino providers data
    },
    /**
     * Retrieves the casino providers.
     * @returns {Array} The casino providers data.
     */
    getProvidersCasino: () => {
        return providersCasino; // Return the casino providers data
    },
    /**
     * Sets the subproviders for casinos.
     * @param {Array} c - The subproviders data to set.
     */
    setSubProvidersCasino: (c) => {
        subprovidersCasino = c; // Set the subproviders data
    },
    /**
     * Retrieves the subproviders for casinos.
     * @returns {Array} The subproviders data.
     */
    getSubProvidersCasino: () => {
        return subprovidersCasino; // Return the subproviders data
    },
    /**
     * Sets the casino games.
     * @param {Array} c - The casino games data to set.
     */
    setGamesCasino: (c) => {
        gamesCasino = c; // Set the casino games data
    },
    /**
     * Retrieves the casino games.
     * @returns {Array} The casino games data.
     */
    getGamesCasino: () => {
        return gamesCasino; // Return the casino games data
    },
    /**
     * Sets the version.
     * @param {string} c - The version to set.
     */
    setVersion: (c) => {
        version = c; // Set the version
    },
    /**
     * Retrieves the version.
     * @returns {string} The version.
     */
    getVersion: () => {
        return version; // Return the version
    },
    /**
     * Sets the online user relationship.
     * @param {string} c - The online user relationship to set.
     */
    setRelationshipUserOnline: (c) => {
        relationshipUserOnline = c; // Set the online user relationship
    },
    /**
     * Retrieves the online user relationship.
     * @returns {string} The online user relationship.
     */
    getRelationshipUserOnline: () => {
        return relationshipUserOnline; // Return the online user relationship
    },
    /**
     * Sets the online user relationship status.
     * @param {boolean} c - The status to set.
     */
    setOnRelationshipUserOnline: (c) => {
        onRelationshipUserOnline = c; // Set the online user relationship status
    },
    /**
     * Retrieves the online user relationship status.
     * @returns {boolean} The online user relationship status.
     */
    getOnRelationshipUserOnline: () => {
        return onRelationshipUserOnline; // Return the online user relationship status
    },
    /**
     * Sets the online user relationship status for virtuals.
     * @param {boolean} c - The status to set.
     */
    setOnRelationshipUserOnlineVirtuals: (c) => {
        onRelationshipUserOnlineVirtuals = c; // Set the online user relationship status for virtuals
    },
    /**
     * Retrieves the online user relationship status for virtuals.
     * @returns {boolean} The online user relationship status for virtuals.
     */
    getOnRelationshipUserOnlineVirtuals: () => {
        return onRelationshipUserOnlineVirtuals; // Return the online user relationship status for virtuals
    },
    /**
     * Sets the wallets list.
     * @param {Array} c - The wallets list data to set.
     */
    setWalletsList: (c) => {
        walletsList = c; // Set the wallets list data
    },
    /**
     * Retrieves the wallets list.
     * @returns {Array} The wallets list data.
     */
    getWalletsList: () => {
        return walletsList; // Return the wallets list data
    },
    /**
     * Sets the permissions.
     * @param {Array} c - The permissions data to set.
     */
    setPerm: (c) => {
        perm = c; // Set the permissions data
    },
    /**
     * Retrieves the permissions.
     * @returns {Array} The permissions data.
     */
    getPerm: () => {
        return perm; // Return the permissions data
    },
    /**
     * Sets the menus.
     * @param {Array} c - The menus data to set.
     */
    setMenus: (c) => {
        menus = c; // Set the menus data
    },
    /**
     * Retrieves the menus.
     * @returns {Array} The menus data.
     */
    getMenus: () => {
        return menus; // Return the menus data
    },
    /**
     * Sets the permission request.
     * @param {string} c - The permission request to set.
     */
    setReqPerm: (c) => {
        requestPerm = c; // Set the permission request
    },
    /**
     * Sets the timezone in the profile settings.
     * @param {string} c - The timezone to set.
     */
    setTimezone: (c) => {
        profile.Settings.TimeZone = c; // Set the timezone in profile settings
    },
    /**
     * Sets the report currency in the profile settings.
     * @param {string} c - The currency to set.
     */
    setCurrencyReport: (c) => {
        profile.Settings.ReportCurrency = c; // Set the report currency in profile settings
    },
    /**
     * Sets the report country in the profile settings.
     * @param {string} c - The country to set.
     */
    setCountryReport: (c) => {
        profile.Settings.ReportCountry = c; // Set the report country in profile settings
    },
    /**
     * Sets the selected partner in the profile.
     * @param {string} c - The partner to set.
     */
    setPartnerSelected: (c) => {
        profile.PartnerSelected = c; // Set the selected partner in profile
    },
    /**
     * Sets the selected machines.
     * @param {Array} c - The machines data to set.
     */
    setMachinesSelected: (c) => {
        machines = c; // Set the selected machines data
    },
    /**
     * Sets the selected banners.
     * @param {Array} c - The banners data to set.
     */
    setBannersSelected: (c) => {
        banners = c; // Set the selected banners data
    },
    /**
     * Retrieves the selected partner from the profile.
     * @returns {string} The selected partner.
     */
    getPartnerSelected: () => {
        return profile.PartnerSelected; // Return the selected partner
    },
    /**
     * Sets the selected subpartner in the profile.
     * @param {string} c - The subpartner to set.
     */
    setSubPartnerSelected: (c) => {
        profile.SubPartnerSelected = c; // Set the selected subpartner in profile
    },
    /**
     * Retrieves the selected subpartner from the profile.
     * @returns {string} The selected subpartner.
     */
    getSubPartnerSelected: () => {
        return profile.SubPartnerSelected; // Return the selected subpartner
    },
    /**
     * Sets the source information.
     * @param {string} c - The source to set.
     */
    setSrc: (c) => {
        src = c; // Set the source information
    },
    /**
     * Retrieves the source information.
     * @returns {string} The source information.
     */
    getSrc: () => {
        return src; // Return the source information
    },
    /**
     * Sets the profile data.
     * @param {Array} c - The profile data to set.
     */
    setProfile: (c) => {
        profile = c; // Set the profile data
    },
    /**
     * Sets the start date.
     * @param {string} c - The start date to set.
     */
    setStartDate: (c) => {
        startDate = c; // Set the start date
    },
    /**
     * Sets the end date.
     * @param {string} c - The end date to set.
     */
    setEndDate: (c) => {
        endDate = c; // Set the end date
    },
    /**
     * Sets the permissions.
     * @param {string} c - The permissions to set.
     */
    setPrm: (c) => {
        prm = c; // Set the permissions
    },
    /**
     * Retrieves the permissions.
     * @returns {string} The permissions.
     */
    getPrm: () => {
        return prm; // Return the permissions
    },
    /**
     * Checks if the report country is set in the profile settings.
     * @returns {boolean} True if the report country is set, otherwise false.
     */
    getCountryReport: () => {
        if (profile.Settings.ReportCountry !== 0 && profile.Settings.ReportCountry !== '' && profile.Settings.ReportCountry !== '0' && profile.Settings.ReportCountry !== undefined) {
            return true; // Report country is set
        } else {
            return false; // Report country is not set
        }
    },
    /**
     * Sets the default data fetch limit.
     * @param {number} c - The limit to set.
     */
    setDefaultDataFetch: (c) => {
        defaultDataFetch = c; // Set the default data fetch limit
    },
    /**
     * Retrieves the default data fetch limit.
     * @returns {number} The default data fetch limit.
     */
    getDefaultDataFetch: () => {
        return defaultDataFetch; // Return the default data fetch limit
    },
    /**
     * Initializes the date range modal with specified language settings.
     * @param {string} lang - The language for the date range picker.
     */
    setDateModal: (lang) => {
        if (lang == 'en') {
            $('.reportrange2 input, .reportrange input').daterangepicker({
                startDate: startDate, // Set the start date
                endDate: endDate, // Set the end date
                ranges: { // Define date ranges
                    'Today': [moment(), moment()],
                    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                },
                locale: { // Define locale settings
                    format: 'YYYY-MM-DD',
                    applyLabel: 'Apply',
                    cancelLabel: 'Cancel',
                    customRangeLabel: 'Custom Range',
                    daysOfWeek: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                },
            }, cb); // Callback function for date selection
        } else {
            if (lang == 'es') {
                $('.reportrange2 input, .reportrange input').daterangepicker({
                    startDate: startDate, // Set the start date
                    endDate: endDate, // Set the end date
                    ranges: { // Define date ranges
                        'Hoy': [moment(), moment()],
                        'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                        'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
                        'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
                        'Este Mes': [moment().startOf('month'), moment().endOf('month')],
                        'Último Mes': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                    },
                    locale: { // Define locale settings
                        format: 'YYYY-MM-DD',
                        applyLabel: 'Aplicar',
                        cancelLabel: 'Cancelar',
                        customRangeLabel: 'Rango personalizado',
                        daysOfWeek: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
                        monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                    },
                }, cb); // Callback function for date selection
            } else {
                if (lang == 'pt') {
                    $('.reportrange2 input, .reportrange input').daterangepicker({
                        startDate: startDate, // Set the start date
                        endDate: endDate, // Set the end date
                        ranges: { // Define date ranges
                            'Hoje': [moment(), moment()],
                            'Ontem': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                            'Últimos 7 dias': [moment().subtract(6, 'days'), moment()],
                            'Últimos 30 dias': [moment().subtract(29, 'days'), moment()],
                            'Este Mês': [moment().startOf('month'), moment().endOf('month')],
                            'Último Mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                        },
                        locale: { // Define locale settings
                            format: 'YYYY-MM-DD',
                            applyLabel: 'Aceitar',
                            cancelLabel: 'Declinar',
                            customRangeLabel: 'Campo Customizado',
                            daysOfWeek: ['Do', 'Se', 'Te', 'Qua', 'Qui', 'Se', 'Sa'],
                            monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
                        },
                    }, cb); // Callback function for date selection
                } else {
                    if(lang == 'tr') {
                        $('.reportrange2 input, .reportrange input').daterangepicker(
                            {
                                startDate: startDate,
                                endDate: endDate,
                                ranges: {
                                    Bugün: [moment(), moment()],
                                    Dün: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                    'Son 7 Gün': [moment().subtract(6, 'days'), moment()],
                                    'Son 30 Gün': [moment().subtract(29, 'days'), moment()],
                                    'Bu Ay': [moment().startOf('month'), moment().endOf('month')],
                                    'Geçen Ay': [
                                        moment().subtract(1, 'month').startOf('month'),
                                        moment().subtract(1, 'month').endOf('month'),
                                    ],
                                },
                                locale: {
                                    format: 'YYYY-MM-DD',
                                    applyLabel: 'Uygula',
                                    cancelLabel: 'İptal',
                                    customRangeLabel: 'Özel Aralık',
                                    daysOfWeek: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
                                    monthNames: [
                                        'Ocak',
                                        'Şubat',
                                        'Mart',
                                        'Nisan',
                                        'Mayıs',
                                        'Haziran',
                                        'Temmuz',
                                        'Ağustos',
                                        'Eylül',
                                        'Ekim',
                                        'Kasım',
                                        'Aralık',
                                    ],
                                },
                            },
                            cb,
                        );
                    }
                }
            }
        }

        function cb(start, end) { // Callback function for date selection
            devConfig.setStartDate(start); // Set the start date
            devConfig.setEndDate(end); // Set the end date
        }
    },
    /**
     * Initializes the date range modal with empty values and specified language settings.
     * @param {string} lang - The language for the date range picker.
     */
    setDateModalEmpty: (lang) => {
        if (lang == 'en') {
            $('.reportrange2 input, .reportrange input').daterangepicker({
                autoUpdateInput: false, // Disable automatic input update
                startDate: startDate, // Set the start date
                endDate: endDate, // Set the end date
                ranges: { // Define date ranges
                    'Today': [moment(), moment()],
                    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                },
                locale: { // Define locale settings
                    format: 'YYYY-MM-DD',
                    applyLabel: 'Apply',
                    cancelLabel: 'Cancel',
                    customRangeLabel: 'Custom Range',
                    daysOfWeek: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                },
            }, cb); // Callback function for date selection
        } else {
            if (lang == 'es') {
                $('.reportrange2 input, .reportrange input').daterangepicker({
                    autoUpdateInput: false, // Disable automatic input update
                    startDate: startDate, // Set the start date
                    endDate: endDate, // Set the end date
                    ranges: { // Define date ranges
                        'Hoy': [moment(), moment()],
                        'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                        'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
                        'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
                        'Este Mes': [moment().startOf('month'), moment().endOf('month')],
                        'Último Mes': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                    },
                    locale: { // Define locale settings
                        format: 'YYYY-MM-DD',
                        applyLabel: 'Aplicar',
                        cancelLabel: 'Cancelar',
                        customRangeLabel: 'Rango personalizado',
                        daysOfWeek: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
                        monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                    },
                }, cb).on('apply.daterangepicker', function(ev, picker) { // Event for applying date range
                    $(this).val(picker.startDate.format('YYYY-MM-DD') + ' - ' + picker.endDate.format('YYYY-MM-DD')); // Set input value to selected date range
                });
            } else {
                if (lang == 'pt') {
                    $('.reportrange2 input, .reportrange input').daterangepicker({
                        autoUpdateInput: false, // Disable automatic input update
                        startDate: startDate, // Set the start date
                        endDate: endDate, // Set the end date
                        ranges: { // Define date ranges
                            'Hoje': [moment(), moment()],
                            'Ontem': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                            'Últimos 7 dias': [moment().subtract(6, 'days'), moment()],
                            'Últimos 30 dias': [moment().subtract(29, 'days'), moment()],
                            'Este Mês': [moment().startOf('month'), moment().endOf('month')],
                            'Último Mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                        },
                        locale: { // Define locale settings
                            format: 'YYYY-MM-DD',
                            applyLabel: 'Aceitar',
                            cancelLabel: 'Declinar',
                            customRangeLabel: 'Campo Customizado',
                            daysOfWeek: ['Do', 'Se', 'Te', 'Qua', 'Qui', 'Se', 'Sa'],
                            monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
                        },
                    }, cb); // Callback function for date selection
                } else {
                    if(lang == 'tr') {
                        $('.reportrange2 input, .reportrange input').daterangepicker({
                            autoUpdateInput: false, // Disable automatic input update
                            startDate: startDate, // Set the start date
                            endDate: endDate, // Set the end date
                            ranges: { // Define date ranges
                                'Bugün': [moment(), moment()],
                                'Dün': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                'Son 7 Gün': [moment().subtract(6, 'days'), moment()],
                                'Son 30 Gün': [moment().subtract(29, 'days'), moment()],
                                'Bu Ay': [moment().startOf('month'), moment().endOf('month')],
                                'Geçen Ay': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                            },
                            locale: { // Define locale settings
                                format: 'YYYY-MM-DD',
                                applyLabel: 'Uygula',
                                cancelLabel: 'İptal',
                                customRangeLabel: 'Özel Aralık',
                                daysOfWeek: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
                                monthNames: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
                            },
                        }, cb); // Callback function for date selection
                    }
                }
            }
        }

        function cb(start, end) { // Callback function for date selection
            devConfig.setStartDate(start); // Set the start date
            devConfig.setEndDate(end); // Set the end date
        }
    },
    /**
     * Retrieves the permission action based on the provided ID and option.
     * @param {string} id - The permission ID to check.
     * @param {string} option - The action option to check (e.g., "Add", "Delete").
     * @returns {boolean} True if the action is permitted, otherwise false.
     */
    getPermAction: (id, option) => {
        for (var i = 0; i < perm.length; i++) { // Iterate through permissions
            if (perm[i].id == id) { // Check if the permission ID matches
                if (option == 'Add') {
                    return true; // Permission to add is granted
                } else {
                    if (option == 'Delete') {
                        // No action needed, just check for delete permission
                    } else {
                        if (option == 'Edit') {
                            return true; // Permission to edit is granted
                        } else {
                            if (option == 'Approve') {
                                return true; // Permission to approve is granted
                            } else {
                                if (option == 'Pay') {
                                    return true; // Permission to pay is granted
                                } else {
                                    if (option == 'Torefuse') {
                                        return true; // Permission to refuse is granted
                                    } else {
                                        if (option == 'Update') {
                                            return true; // Permission to update is granted
                                        } else {
                                            if (option == 'Commands') {
                                                return true; // Permission for commands is granted
                                            } else {
                                                if (option == 'Menu') {
                                                    return true; // Permission for menu access is granted
                                                } else {
                                                    if (option == 'Switch') {
                                                        return true; // Permission to switch is granted
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                if (perm[i].menu) { // Check if the permission has a menu
                    for (var j = 0; j < perm[i].menu.length; j++) { // Iterate through menu permissions
                        if (perm[i].menu[j].id == id) { // Check if the menu ID matches
                            if (option == 'Add') {
                                if (perm[i].menu[j].add == true) {
                                    return true; // Permission to add is granted
                                } else {
                                    return false; // Permission to add is denied
                                }
                            } else {
                                if (option == 'Delete') {
                                    if (perm[i].menu[j].delete == true) {
                                        return true; // Permission to delete is granted
                                    } else {
                                        return false; // Permission to delete is denied
                                    }
                                } else {
                                    if (option == 'Edit') {
                                        if (perm[i].menu[j].edit == true) {
                                            return true; // Permission to edit is granted
                                        } else {
                                            return false; // Permission to edit is denied
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return false; // No permission found for the action
    },
};

// FILE DOCUMENTED
